import { useNavigate, useLocation } from "react-router-dom";
import { Plus, Settings } from "lucide-react";
import { Button } from "./ui/button";

export function TopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const onDashboard = location.pathname === "/";

  return (
    <header className="sticky top-0 z-30 bg-[#152E22] text-white border-b border-black/20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <button
          data-testid="topbar-home-button"
          onClick={() => navigate("/")}
          className="flex items-center gap-2.5 group"
        >
          <span className="h-9 w-9 rounded-lg overflow-hidden shrink-0 ring-1 ring-white/20">
            <img src="/logo.jpg" alt="Affordable Stump Grinding" className="h-full w-full object-cover" />
          </span>
          <span className="text-left leading-tight">
            <span className="block font-headline font-bold text-[15px] tracking-tight">Affordable</span>
            <span className="block text-[10px] uppercase tracking-widest text-emerald-200/70">Stump Grinding</span>
          </span>
        </button>

        <div className="flex items-center gap-2">
          {!onDashboard && (
            <Button
              data-testid="new-invoice-button"
              onClick={() => navigate("/invoice/new")}
              className="bg-[#D97706] hover:bg-[#b96205] text-white h-10 rounded-lg font-semibold"
            >
              <Plus className="h-4 w-4 mr-1" /> New
            </Button>
          )}
          <button
            data-testid="settings-button"
            onClick={() => navigate("/settings")}
            title="Settings"
            className="h-10 w-10 flex items-center justify-center rounded-lg text-emerald-100 hover:bg-white/10 transition-colors"
          >
            <Settings className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
